import { createFileRoute } from '@tanstack/react-router';
import { useUser } from '@clerk/clerk-react';
import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import { DocsPage } from '../components/DocsPage';
import { getConvexHttpUrl } from '../utils/convex';

export const Route = createFileRoute('/docs')({
  component: DocsRoute,
});

function DocsRoute() {
  const { user: clerkUser, isLoaded } = useUser();
  const serviceKey = useQuery(
    api.users.getUserServiceKey,
    clerkUser ? undefined : 'skip'
  );

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-terminal-black">
        <div className="text-terminal-orange">Loading...</div>
      </div>
    );
  }

  return (
    <DocsPage
      serviceKey={serviceKey?.serviceApiKey}
      convexSiteUrl={clerkUser ? getConvexHttpUrl() : undefined}
    />
  );
}
